import Constants from '../constants'
import favorite from './favorite'
import genre from './genre'
import place from './place'
import station from './station'
import location from './location'
import point from './point'
import translation from './translation'
import analytics from './analytics'
import axios from 'axios'
import course from './course'
import notice from './notice'
import route from './route'

// jestでaxiosはmockにするのでその時はセットしない
if (axios.defaults) {
  axios.defaults.baseURL = Constants.API_BASE_URL
  axios.defaults.responseType = 'json'
}

const api = {
  ...genre,
  ...favorite,
  ...place,
  ...station,
  ...location,
  ...point,
  ...translation,
  ...analytics,
  ...course,
  ...notice,
  ...route
}

export default api
